import { FC, useState } from "react";
import Select from "@aleaplay/web-components/ui/Select";

import { FormChildProps } from "@/v1/components/atoms/FormChild";

import { TreeItem } from "./components/TreeItem/TreeItem";

import "./treeSelect.scss";

interface TreeSelectProps extends FormChildProps {
  options?: any[];
}

export const TreeSelect: FC<TreeSelectProps> = ({ options, ...props }) => {
  const [displayDepth, setDisplayDepth] = useState(false);

  return (
    <div className="tree-select">
      <Select
        onOpen={() => setDisplayDepth(true)}
        onClose={() => setDisplayDepth(false)}
        {...props}
      >
        {options?.map(item => (
          <Select.Option key={item.lastUpdated} value={item.path}>
            <TreeItem displayDepth={displayDepth} label={item.name} depth={item.depth} />
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};
